<div class="dropdown-list dropdown-list--grey parameters">
    @if (tile.params.valveNumber > 0) {
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ labels.valveNumber }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">{{ tile.params.valveNumber }}</p>
            </div>
        </div>
    }
    @if (tile.params.sourceTemp > -2000) {
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ labels.sourceTemp }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.sourceTemp | format:7 }}
                </p>
            </div>
        </div>
    }
    <div class="dropdown-list__item color-basic font-12 font-bold">
        <p class="dropdown-list__item-name">{{ labels.currentTemp }}</p>
        <div class="dropdown-list__value dropdown-list__value--single">
            <p class="dropdown-list__value-name">
                {{ tile.params.currentTemp | format:7 }}
            </p>
        </div>
    </div>
    <div class="dropdown-list__item color-basic font-12 font-bold">
        <p class="dropdown-list__item-name">{{ labels.setTemp }}</p>
        <div class="dropdown-list__value dropdown-list__value--single">
            <p class="dropdown-list__value-name">
                {{ tile.params.setTemp | format:7 }}
            </p>
        </div>
    </div>
    <div class="dropdown-list__item color-basic font-12 font-bold">
        <p class="dropdown-list__item-name">{{ labels.openingPercentage }}</p>
        <div class="dropdown-list__value dropdown-list__value--single">
            <p class="dropdown-list__value-name">
                {{ tile.params.openingPercentage | format:8 }}
            </p>
        </div>
    </div>
    @if (tile.params.valvePump !== -1) {
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ labels.valvePump }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">{{ valvePumpLabel }}</p>
            </div>
        </div>
    }
    @if (tile.params.floorProtection > -2000) {
        <div class="dropdown-list__item color-basic font-12 font-bold">
            <p class="dropdown-list__item-name">{{ labels.floorProtection }}</p>
            <div class="dropdown-list__value dropdown-list__value--single">
                <p class="dropdown-list__value-name">
                    {{ tile.params.floorProtection | format:7 }}
                </p>
            </div>
        </div>
    }
    <div class="dropdown-list__item color-basic font-12 font-bold">
        <p class="dropdown-list__item-name">{{ labels.version }}</p>
        <div class="dropdown-list__value dropdown-list__value--single">
            <p class="dropdown-list__value-name">{{ version }}</p>
        </div>
    </div>
</div>
